import { useEffect, useRef } from 'react'

export enum MouseEventType {
  Mousedown = 'mousedown',
  Click = 'click',
  TouchStart = 'touchstart',
}

const DEFAULT_MOUSE_EVENTS = [MouseEventType.Mousedown]

const useClickOutside = <T extends HTMLDivElement>(
  callback: () => void,
  mouseEventTypes = DEFAULT_MOUSE_EVENTS,
) => {
  const wrapperNode = useRef<T>(null)

  useEffect(() => {
    const handleMouseEvent: EventListener = (e: Event) => {
      const insideRef = wrapperNode.current
      const clickedElement = e.target
      if (insideRef && clickedElement instanceof Node) {
        if (insideRef.contains(clickedElement)) return

        callback()
      }
    }
    mouseEventTypes.forEach(eventType => {
      document.addEventListener(eventType, handleMouseEvent)
    })

    return () => {
      mouseEventTypes.forEach(eventType => {
        document.removeEventListener(eventType, handleMouseEvent)
      })
    }
  }, [callback, mouseEventTypes])

  return wrapperNode
}

export default useClickOutside
